<template>
  <div id="geowerft-full-wrapper" v-bind:class="mw_set_main_geo_class()">
    <div
      class="message"
      v-if="geoWerftData.hasError"
      style="color: red; font-weight: bold; font-size: 300%"
    >
      {{ geoWerftData.hasError }}
    </div>
    <div v-if="geoWerftData.texts.map_h1" class="geowerft-h1-wrapper">
      <h1>{{ geoWerftData.texts.map_h1 }}</h1>
    </div>
    <object-filter v-bind:geoWerftData="geoWerftData"></object-filter>
    <object-map
      v-if="true === geoWerftData.map_enabled"
      v-bind:geoWerftData="geoWerftData"
    ></object-map>
    <div
      data-nosnippet="true"
      v-if="false === geoWerftData.map_enabled"
      class="geowerft-consent-wrapper"
    >
      <div class="mw-disable-google-maps-wrapper">
        <div class="mw-disable-google-maps">
          <p class="mw-consent-management-info-text">
            {{ geoWerftData.texts.consent_text_normal }}
          </p>
          <div
            v-bind:class="get_consent_reset_class()"
            v-on:click="do_cookie_consent()"
          >
            {{ geoWerftData.texts.consent_button_label }}
          </div>
        </div>
      </div>
    </div>
    <object-list v-bind:geoWerftData="geoWerftData"></object-list>
  </div>
</template>

<script>
// Imports
import objectList from "./components/objectList.vue";
import objectMap from "./components/objectMap.vue";
import objectFilter from "./components/objectFilter.vue";
import is_consent_google_maps from "./check-consent";
import can_use_ccm_with_map from "./check-ccm";

export default {
  name: "GeoWerft",
  components: {
    "object-list": objectList,
    "object-map": objectMap,
    "object-filter": objectFilter,
  },
  data() {
    return {
      geoWerftData: {
        objects: {
          all: [],
          filtered: [],
          visible: [],
          listed: [],
        },
        cookie_bot: window.Cookiebot || false,
        map_enabled:
          is_consent_google_maps() === true ||
          (false !== (window.Cookiebot || false) &&
            true === window.Cookiebot.consent.marketing) ||
          true === can_use_ccm_with_map(),
        map: {
          bound: {
            northEast: {
              lat: null,
              lng: null,
            },
            southWest: {
              lat: null,
              lng: null,
            },
          },
          center: {
            lat: 50.87071,
            lng: 6.9750813,
          },
          zoom: 10,
          maxZoom: 21,
          zoom_types: [],
          markers: [],
          no_cluster_markers: [],
          map_type_id: "roadmap",
          map_touch_mode: "cooperative",
          map_zoom_control: true,
        },
        cluster_font_weight: 400,
        currentMarker: null,
        search: "",
        source_url: "",
        page_count: 50,
        media_url: "",
        filialien_url: "",
        source_api: "",
        estate_agent_email_filter: "",
        image_placeholder_secret: "",
        image_placeholder_empty: "",
        image_placeholder_house_prep: "",
        image_placeholder_flat_prep: "",
        image_placeholder_plot_prep: "",
        image_placeholder_invest_prep: "",
        image_placeholder_market_watch: "",
        image_placeholder_market_watch_house: "",
        image_placeholder_market_watch_flat: "",
        image_placeholder_market_watch_plot: "",
        custom_loading_icon: "",
        geowerft_immo_loading: true,
        geowerft_no_props_from_route: false,
        additional_content: {
          geowerft_additional_info_box: false,
          geowerft_additional_info_box_template: "",
        },
        checkboxes: {
          display_tour_icon: false,
          display_ges_flaeche: false,
          show_price_in_paginated_info_window: false,
          show_map_satellite_switch: false,
          picture_click_always_active: false,
          user_has_searchwish: false,
          prop_offline_include_overlay: false,
          prop_offline_single_overlay: false,
          display_google_search: false,
          display_custom_pin_in_list: false,
          format_prices_cb: false,
          show_price_prop_sold: false,
          show_in_prep_banner: false,
          show_price_prop_referenz: false,
          show_loading_icon: false,
          other_info_window: false,
          other_info_window_v2: false,
          show_geo_as_fallback: false,
          display_prep_price: false,
          display_extra_commision_info: false,
          display_sorce_in_market_watch: false,
          display_picture_max_width_or_height: true,
          enable_filialen_mode: false,
          list_map_switcher: false,
          display_marketing_method: false,
          select_cluster_active: false,
          secret_bar_active: false,
          show_ground_fl_for_house_in_list: false,
          custom_marketwatch_temp_active: false,
          next_pin_active: false,
          set_geolocation: false,
          enable_tutorial: false,
          advanced_list_view: false,
          logged_in_market_watch: false,
          picture_click_active: false,
          enable_market_watch_ajax: false,
          allow_prop_offline_detection: false,
          allow_prop_offline_detection_only_logged_in: false,
          exclude_in_closest_prop: false,
          hide_picture_shadow: false,
          show_more_info_in_list: false,
          show_warmmiete: false,
          fill_prop_types_to_invest: false,
          display_plz_in_object_place: false,
          display_kennung_in_object_place: false,
        },
        texts: {
          currency_suffix: "€",
          autocomplete_placeholder: "",
          fill_prop_types_to_invest_list: "",
          auction_popup_picture: "",
          label_flaeche_list_view: "Fläche",
          label_bezug_ab_map_view: "Bezug ab: ",
          mietpreis_pro_qm_pre: "",
          info_window_obj_nr: "Objekt Nr.:",
          mietpreis_pro_qm_post: "",
          wp_nonce: "",
          prop_offline_tutorial_text: "",
          prop_offline_picture: "",
          prop_offline_success_text: "",
          prop_offline_explain_text: "",
          prop_offline_akt_kind: "",
          prop_offline_akt_type: "",
          prop_offline_hp_status: "",
          exclude_in_closest_prop_status: "",
          display_text_price_rent: "",
          display_text_price_purchase: "",
          display_text_no_buyer_comission: "",
          display_extra_banderole: "",
          no_immo_in_bounds_text: "",
          no_immo_in_bounds_text_list_view: "",
          prop_loading_text: "",
          market_watch_name: "",
          prop_own_source_text: "",
          select_cluster_hp_to_show: "",
          not_in_scope_text: "",
          map_h1: "",
          sc_plz: "",
          sc_geolage: "",
          label_details: "",
          secret_bar_register_link: "",
          secret_sale_headline: "",
          secret_sale_sub_text: "",
          secret_sale_button: "",
          blur_hp_status_name: "",
          text_next_pin_prop: "",
          text_button_next_pin_prop: "",
          text_filter_next_pin_prop: "",
          text_next_pin_ppl: "",
          text_button_next_pin_ppl: "",
          text_sc_info_text: "",
          consent_text_normal: "",
          consent_button_label: "",
          zoom_out_type: "",
          tutorial_text_one: "",
          tutorial_text_two: "",
          tutorial_text_three: "",
          market_watch_alt_link: "",
          ajax_url: "",
          market_watch_akt_kind: "",
          market_watch_akt_type: "",
          banner_picture_link_second: "",
          banner_picture_src_second: "",
          geo_banner_picture_link: "",
          geo_banner_picture_src: "",
          geo_banner_picture_src_list: "",
          geo_banner_custom_html: "",
          banner_mobile_first_link: "",
          banner_mobile_first_px: "768",
          banner_mobile_second_link: "",
          banner_mobile_second_px: "768",
          filter_label_price: "",
          filter_adults_label: "Erwachsene",
          filter_children_label: "Kinder",
          filter_label_price_buy: "",
          filter_label_price_rent: "",
          filter_label_space: "",
          filter_label_rooms: "",
          filter_space_label_house: "",
          filter_space_label_grundstueck: "",
          filter_space_label_gewerbe: "",
          filter_space_label_invest: "",
          filter_space_label_house_max_extension: "",
          filter_space_label_grundstueck_max_extension: "",
          filter_space_label_gewerbe_max_extension: "",
          filter_space_label_invest_max_extension: "",
          custom_pre_filter_label_von: "",
          custom_pre_filter_label_bis: "",
          use_buero_for_business_space: "false",
          reload_secret_sale_price_for_logged_in: "false",
          no_prop_in_route_text: "",
          diff_extern_link: "",
          list_visibility_json: "",
        },
        customimages: {
          tutorial_picture_one: "",
          tutorial_picture_two: "",
          tutorial_picture_three: "",
          tour_icon_src: "",
        },
        marker_image: {
          google_maps_marker_online: "",
          google_maps_marker_in_vorbereitung: "",
          google_maps_marker_marktbeobachtung: "",
          google_maps_marker_verkauft: "",
          google_maps_marker_referenz: "",
          google_maps_marker_secret_sale: "",
          google_maps_marker_neubauobjekt: "",
          google_maps_marker_neubaureferenz: "",
          google_maps_marker_exlusive_object: "",
          google_maps_marker_badge_new: "",
          google_maps_marker_auction: "",
          google_maps_marker_mietboerse: "",
          google_maps_marker_immobiliendepot: "",
          google_maps_marker_default: "",
        },
        map_settings: {
          google_search_zoom_level: 18,
        },
        custom_map_style: "",
        current_map_mode: "map",
        list_item_limit: 200,
        list_item_limit_old: 0,
        hasError: false,
        show_cluster: false,
        show_cluster_no_pictures: true,
        cluster_break_zoom: 15,
        cluster_pin_near: "",
        cluster_pin_far: "",
        show_sold_banner: false,
        step_num_kauf: 100000,
        step_num_miete: 50,
        display_step: 50,
        steps_rooms: 1,
        steps_space: 50,
        steps_living_space: 50,
        steps_plot_space: 100,
        auction_list_label: "Bieterverfahren",
        geowerft_setting_watchlist_icon: false,
        geowerft_setting_watchlist_icon_custom: "",
        show_einheiten_in_list: false,
        geowerft_gtb_active: false,
        use_img_tag_in_list: false,
        geowerft_gtb_watchlist_active: false,
        geowerft_gtb_watchlist_active_detailed: false,
        geowerft_gtb_watchlist_rest: "",
        show_prov_free_banner: false,
        show_extern_link: false,
        secret_bar_max_count: 0,
        //is_loading: false,
        filter: [],
        user: {
          logged_in: false,
          has_dsn: false,
          current_user_id: 0,
          user_fully_logged_in: false,
          link_for_logged_in_only: false,
          link_for_logged_in_only_url: "/mein-konto",
          link_for_logged_in_only_label: "Bitte einloggen",
        },
        extra_class: "mw-geowerft-multiple-selects",
        extra_class_nums: "mw-geowerft-multiple-selects-nums",
        kennung_filter_caption: "Kennung",
        energie_filter_caption: "Energieeffizienz",
        kennung_filter_placeholder: "Kennung eingeben",
        energie_filter_placeholder: "Energieeffizienz wählen",
        prop_watchlist_active: false,
        prop_watchlist_offline_mode: false,
        user_watchlist: "",
        user_watchlist_detailed: "",
        user_blacklist: "",
        user_blacklist_icon: "",
        geo_display_objecttype: false,
        filialen_landingpage_label: "Zum Immobilien-Profi",
        filialen_success_story_label: "Zur Success-Story",
        geo_business_mode: false,
        geo_business_mode_bueroflaeche: false,
        watchlist_to_hide_hp: "",
        watchlist_to_hide_vermarktung: "",
        array_container: [],
        interactive_filter_active: false,
        show_dialog_filter: [],
        show_more_filter: [],
        enable_comfort_zoom: false,
        enable_blacklist: false,
        display_map_list_switch: false,
        price_on_request_cb: false,
        enable_class_for_diff_view: false,
        extra_map_css_class: "",
        marketwatch_extern_links_hp: [],
        reset_bounds: false,
        reset_bounds_label: "Auf Anfang",
        list_view_config: {},
        show_more_filter_close_btn_label: "Filter anwenden",
        enable_ai_quick_chat: false,
        enable_ai_quick_chat_custom: "",
        ai_quick_label: "",
        ai_quick_placeholder: "",
        ai_quick_svg: "",
        ai_load_img: "",
        ai_load_img_pre: "",
        ai_load_img_after: "",
        ai_load_text: "",
      },
    };
  },
  computed: {
    allObjects: function () {
      return this.geoWerftData.objects.all;
    },
    filteredObjects: function () {
      return this.allObjects.filter((object) => {
        // Wenn der Filialien Modus an ist alles durch lassen.
        if (this.geoWerftData.checkboxes.enable_filialen_mode) {
          return true;
        }

        // Set default - show object
        let result = true;
        let filter_invalid = false;

        for (let key in this.geoWerftData.filter) {
          if (true === filter_invalid) {
            break;
          }

          // Skip filter if the property is from prototype
          if (!this.geoWerftData.filter.hasOwnProperty(key)) {
            continue;
          }

          // The filter to check
          let filter = this.geoWerftData.filter[key];

          // Neue Filter methode verwenden.
          if (true === this.geoWerftData.interactive_filter_active) {
            // Wichtig, bevor die Filter wirken können, muss geprüft werden, ob bestimmte requirements getroffen sind.
            let arr_requirements = filter.requires || [];
            let tmp_require_check_value;
            let bool_skip_filter = false;
            let arr_requirements_size = Object.keys(arr_requirements).length;
            if (arr_requirements_size >= 1) {
              // Hier nun prüfen, welche requirements gegeben sind.
              for (const [tmp_key, tmp_arr_values] of Object.entries(
                arr_requirements
              )) {
                tmp_require_check_value =
                  this.geoWerftData.filter[tmp_key] || [];
                tmp_require_check_value = tmp_require_check_value.value || "";
                if (
                  "" === tmp_require_check_value ||
                  (!Array.isArray(tmp_require_check_value) &&
                    !tmp_arr_values.includes(tmp_require_check_value)) ||
                  (Array.isArray(tmp_require_check_value) &&
                    !tmp_require_check_value.some((val) =>
                      tmp_arr_values.includes(val)
                    ))
                ) {
                  bool_skip_filter = true;
                  // Aktuellen Filter leeren, falls dieser verwendet wurde.
                  if (Array.isArray(filter.value)) {
                    filter.value = [];
                  } else {
                    filter.value = "";
                  }
                }
              }
            }

            if (bool_skip_filter) {
              // requirements sind nicht gegeben, also den Filter nicht berücksichtigen.
              continue;
            }

            let current_compare_mode = filter.compare || "=";
            let working_key = String(key)
              .replace("_from", "")
              .replace("_to", "");
            let current_prop_value = (object[working_key] || "")
              .toLowerCase()
              .replace("buy", "kauf")
              .replace("rent", "miete");
            let filter_is_empty = 0 === filter.value.length;
            let tmp_value_for_check = filter.value || "";
            let alternative_compare_array = [];
            const possible_compare_main = filter.compare_array || [];
            // Anpassung für Array Werte
            if (
              Array.isArray(tmp_value_for_check) &&
              tmp_value_for_check.length > 1
            ) {
              alternative_compare_array = [];
              tmp_value_for_check.forEach(function (selected_value) {
                if (Array.isArray(possible_compare_main[selected_value])) {
                  alternative_compare_array.push(
                    ...(possible_compare_main[selected_value] || [])
                  );
                }
              });
            } else {
              alternative_compare_array =
                possible_compare_main[tmp_value_for_check] || [];
            }

            switch (current_compare_mode) {
              case "contains":
                if (false === filter_is_empty) {
                  if (Array.isArray(filter.value)) {
                    filter.value.forEach(function (single_value) {
                      let tmp_regex = new RegExp(single_value.toLowerCase());
                      if (false === tmp_regex.test(current_prop_value)) {
                        result = false;
                        filter_invalid = true;
                      }
                    });
                  } else {
                    let tmp_regex = new RegExp(filter.value.toLowerCase());
                    if (false === tmp_regex.test(current_prop_value)) {
                      result = false;
                      filter_invalid = true;
                    }
                  }
                }
                break;
              case "instr":
                if (
                  false === filter_is_empty &&
                  -1 === current_prop_value.indexOf(filter.value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "IN":
                let tmp_compare_arr = filter.value;
                if (alternative_compare_array.length > 1) {
                  tmp_compare_arr = alternative_compare_array;
                }

                // Sonderfall für Energieausweis hinzufügen.
                if (
                  "epass_wertklasse" === working_key &&
                  "" === current_prop_value
                ) {
                  current_prop_value = "h";
                }

                if (
                  false === filter_is_empty &&
                  false === tmp_compare_arr.includes(current_prop_value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "INCONTAINS":
                let tmp_compare_arr_alt = filter.value;
                if (alternative_compare_array.length > 1) {
                  tmp_compare_arr_alt = alternative_compare_array;
                }
                // Prop Values Arr
                let curr_prop_values_arr = current_prop_value
                  .split(",")
                  .map((item) => item.trim());
                let found_one = false;
                tmp_compare_arr_alt.forEach(function (single_value) {
                  curr_prop_values_arr.forEach(function (single_prop_value) {
                    if (
                      single_value.toLowerCase() ===
                      single_prop_value.toLowerCase()
                    ) {
                      found_one = true;
                    }
                  });
                });

                if (false === filter_is_empty && false === found_one) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "=":
                if (
                  false === filter_is_empty &&
                  filter.value !== current_prop_value
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "buildyear_from":
                if (
                  false === filter_is_empty &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) > parseInt(current_prop_value) &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) !== parseInt(current_prop_value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "buildyear_to":
                if (
                  false === filter_is_empty &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) < parseInt(current_prop_value) &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) !== parseInt(current_prop_value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case "<=":
                if (
                  false === filter_is_empty &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) < parseFloat(current_prop_value) &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) !== parseFloat(current_prop_value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
              case ">=":
                if (
                  false === filter_is_empty &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) > parseFloat(current_prop_value) &&
                  this.mw_interactive_remove_currency_and_not_working_chars(
                    filter.value,
                    filter.format || ""
                  ) !== parseFloat(current_prop_value)
                ) {
                  result = false;
                  filter_invalid = true;
                }
                break;
            }
          } else {
            // Alte Filter variante.
            if (typeof filter.value === "object") {
              // Filter with min and max

              // Get the min limit
              let min = parseFloat(filter.value.min);
              // Check if a automatic limit is needed
              if (isNaN(min)) {
                min = 0;
              }
              // Get the max limit
              let max = parseFloat(filter.value.max);
              // Check if a automatic limit is needed
              if (isNaN(max)) {
                max = Infinity;
              }

              // Go to right filter
              switch (String(key)) {
                case "adults":
                  this.geoWerftData.display_step = this.geoWerftData.step_num_kauf;
                  let current_count = 0;
                  if (object.count_adults) {
                    current_count = parseInt(object.count_adults);
                  }
                  if (current_count < min || current_count > max) {
                    result = false;
                  }
                  break;
                case "children":
                  this.geoWerftData.display_step = this.geoWerftData.step_num_kauf;
                  let current_count_childs = 0;
                  if (object.count_childs) {
                    current_count_childs = parseInt(object.count_childs);
                  }
                  if (
                    current_count_childs < min ||
                    current_count_childs > max
                  ) {
                    result = false;
                  }
                  break;
                case "price":
                  // Set default price
                  let object_price = "";
                  // Try to find the sale price
                  if (
                    this.geoWerftData.filter["acquisition"].value == "miete" ||
                    this.geoWerftData.filter["acquisition"].value == "rent"
                  ) {
                    // Try to find the rental price
                    if (
                      typeof object.nettokaltmiete !== "undefined" &&
                      0 !== object.nettokaltmiete.length
                    ) {
                      object_price = parseInt(object.nettokaltmiete);
                    }
                    if (
                      "" === object_price &&
                      typeof object.mietpreis_pro_qm !== "undefined" &&
                      0 !== object.mietpreis_pro_qm.length
                    ) {
                      object_price = parseInt(object.mietpreis_pro_qm);
                    }
                  } else {
                    if (
                      typeof object.kaufpreis !== "undefined" &&
                      0 !== object.kaufpreis.length
                    ) {
                      object_price = parseInt(object.kaufpreis);
                    }
                  }

                  // Check if price is between min and max value
                  if (
                    "" !== object_price &&
                    (object_price < min || object_price > max)
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "rooms":
                  let compare_rooms_field;
                  switch (this.geoWerftData.filter["objecttype"].value) {
                    case "house":
                      compare_rooms_field = object.wohnflaeche;
                      break;
                    case "plot":
                      compare_rooms_field = object.grundstuecksflaeche;
                      break;
                    case "business":
                      compare_rooms_field = object.gesamtflaeche;
                      if (
                        object.bueroflaeche &&
                        "true" ===
                          this.geoWerftData.use_buero_for_business_space
                      ) {
                        compare_rooms_field = object.bueroflaeche;
                      }
                      break;
                    case "investment":
                      compare_rooms_field = object.vermietbare_flaeche;
                      break;
                    default:
                      compare_rooms_field = object.anzahl_zimmer;
                      break;
                  }

                  let tmp_rooms = 0;
                  if (compare_rooms_field) {
                    tmp_rooms = parseFloat(
                      compare_rooms_field.replace(",", ".")
                    );
                  }
                  if (isNaN(tmp_rooms)) {
                    tmp_rooms = 0;
                  }

                  // Wenn der Gewerbe Modus aktiv ist und eine Teilbarkeit zum Objekt angegeben ist, dann wird die
                  // Teilbarkeit mit einberechnet.
                  if (
                    "business" === this.geoWerftData.filter["objecttype"].value
                  ) {
                    // Wenn keine Bürofläche im Objekt angegeben wurde dann diese auf 99999 setzten damit nach diesen
                    // immer noch gefiltert werden kann.
                    if (tmp_rooms === 0) {
                      tmp_rooms = 99999;
                    }
                    let tmp_teilbarkeit = Infinity;
                    if (object.teilbar_ab) {
                      tmp_teilbarkeit = parseFloat(
                        object.teilbar_ab.replace(",", ".")
                      );
                    }
                    if (isNaN(tmp_teilbarkeit)) {
                      tmp_teilbarkeit = Infinity;
                    }
                    let bool_tmp_teil = tmp_teilbarkeit > max;
                    let bool_tmp_max = tmp_rooms > max;
                    let hide_current_prop = false;
                    if (bool_tmp_max === true) {
                      hide_current_prop = true;
                    }
                    if (bool_tmp_teil === false) {
                      hide_current_prop = false;
                    }
                    if (tmp_rooms < min || hide_current_prop === true) {
                      result = false;
                      break;
                    }
                    break;
                  }

                  if (tmp_rooms < min || tmp_rooms > max) {
                    result = false;
                    break;
                  }
                  break;
                default:
                  break;
              }
            } else {
              // Filter with drop-down
              switch (String(key)) {
                case "customfilter":
                  if (0 === filter.value.length) {
                    break;
                  }
                  // Prüfen, ob das Feld in der Immobilie existiert.
                  if (
                    geowerftSettings.custom_compare_meta &&
                    object[geowerftSettings.custom_compare_meta] &&
                    object[geowerftSettings.custom_compare_meta] === ""
                  ) {
                    result = false;
                    break;
                  }
                  if (
                    filter.value !==
                    object[geowerftSettings.custom_compare_meta]
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "acquisition":
                  // Check if a filter value was given
                  if (0 === filter.value.length) {
                    break;
                  }
                  // Check acquisitions
                  if (
                    object.erwerbsart &&
                    "buy" === filter.value &&
                    object.erwerbsart.toLowerCase() !== "buy" &&
                    object.erwerbsart.toLowerCase() !== "kauf"
                  ) {
                    this.geoWerftData.display_step = this.geoWerftData.step_num_kauf;
                    // Buying selected, but object is not fore sale
                    result = false;
                    break;
                  } else if (
                    object.erwerbsart &&
                    "rent" === filter.value &&
                    object.erwerbsart.toLowerCase() !== "rent" &&
                    object.erwerbsart.toLowerCase() !== "miete"
                  ) {
                    this.geoWerftData.display_step = this.geoWerftData.step_num_miete;
                    // Renting selected, but object is not for rent
                    result = false;
                    break;
                  }
                  break;
                case "objecttype":
                  // Check if the value can be worked with
                  if (!object.objektart_geowerft && !object.objektart_raw) {
                    result = false;
                    break;
                  }

                  var objektart_filter =
                    object.objektart_geowerft || object.objektart_raw || "";
                  if (objektart_filter) {
                    objektart_filter = objektart_filter.toLowerCase();
                    objektart_filter = objektart_filter.replace("&#252;", "ü");
                    objektart_filter = objektart_filter.replace("&#228;", "ä");
                    objektart_filter = objektart_filter.replace("&#246;", "ö");
                  }

                  if (
                    "buero_praxis" === filter.value ||
                    "einzelhandel" === filter.value ||
                    "lager_produktion" === filter.value
                  ) {
                    // Bei diesen übergaben, Objektart_raw bevorzugen.
                    objektart_filter =
                      object.objektart_raw || object.objektart_geowerft || "";
                    objektart_filter = objektart_filter.toLowerCase();
                  }

                  let general_include = false;
                  for (let option_key in geowerftSettings.filter["objecttype"]
                    .options) {
                    if ("" === option_key.toString()) {
                      continue;
                    }
                    if (
                      object.objekttyp &&
                      (option_key.toString() === "villa" ||
                        option_key.toString() === "rest")
                    ) {
                      objektart_filter = object.objekttyp.toLowerCase();
                    }

                    const object_type_values = require(`./data/${option_key.toString()}.js`);

                    // Hier noch in speziellen fällen weitere Objekttypen zumischen.
                    if (
                      geowerftSettings.arr_additional_prop_type &&
                      geowerftSettings.arr_additional_prop_type[0] &&
                      geowerftSettings.arr_additional_prop_type[1]
                    ) {
                      if (
                        geowerftSettings.arr_additional_prop_type[0] ===
                          option_key &&
                        !object_type_values.includes(
                          geowerftSettings.arr_additional_prop_type[1]
                        )
                      ) {
                        object_type_values.push(
                          geowerftSettings.arr_additional_prop_type[1]
                        );
                      }
                    }

                    const object_type_values_small = object_type_values.map(
                      (x) => x.toLowerCase()
                    );
                    // Set the result var to false if no match found
                    if (
                      true ===
                      object_type_values_small.includes(objektart_filter)
                    ) {
                      general_include = true;
                      break;
                    }
                  }

                  if (false === general_include) {
                    result = false;
                    break;
                  }

                  // Check if a filter value was given
                  if (0 === filter.value.length) {
                    break;
                  }

                  // Get array of possible values
                  const object_type_values = require(`./data/${filter.value}.js`);
                  const object_type_values_small = object_type_values.map((x) =>
                    x.toLowerCase()
                  );

                  // Wenn der Customizer an ist und das result auf false steht noch einmal mit dem Objekttypen versuchen.
                  if (
                    object.objekttyp &&
                    "investment" === filter.value &&
                    true ===
                      this.geoWerftData.checkboxes.fill_prop_types_to_invest &&
                    this.geoWerftData.texts.fill_prop_types_to_invest_list.includes(
                      object.objekttyp
                    )
                  ) {
                    objektart_filter = "investment";
                  }

                  // Set the result var to false if no match found
                  if (
                    false ===
                    object_type_values_small.includes(objektart_filter)
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "status":
                  // Check if the value can be worked with
                  if (!object.homepage_status) {
                    result = false;
                    break;
                  }

                  // Check if a status is given
                  if (
                    0 !== filter.value.length &&
                    filter.value.toLowerCase() !==
                      object.homepage_status.toLowerCase()
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "energie":
                  // Energieeffizienz aus dem Objekt lesen.
                  var current_value = object.epass_wertklasse || "";

                  switch (filter.value) {
                    case "A+":
                      if (!["A+"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "A":
                      if (!["A+", "A"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "B":
                      if (!["A+", "A", "B"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "C":
                      if (!["A+", "A", "B", "C"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "D":
                      if (!["A+", "A", "B", "C", "D"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "E":
                      if (
                        !["A+", "A", "B", "C", "D", "E"].includes(current_value)
                      ) {
                        result = false;
                      }
                      break;
                    case "F":
                      if (
                        !["A+", "A", "B", "C", "D", "E", "F"].includes(
                          current_value
                        )
                      ) {
                        result = false;
                      }
                      break;
                    case "G":
                      if (
                        !["A+", "A", "B", "C", "D", "E", "F", "G"].includes(
                          current_value
                        )
                      ) {
                        result = false;
                      }
                      break;
                    case "H":
                      if (
                        ![
                          "A+",
                          "A",
                          "B",
                          "C",
                          "D",
                          "E",
                          "F",
                          "G",
                          "H",
                        ].includes(current_value)
                      ) {
                        result = false;
                      }
                      break;
                  }

                  break;
                case "marketing":
                  // Check if the value can be worked with
                  if (!object.vermarktungsart) {
                    result = false;
                    break;
                  }

                  // Check if a status is given
                  if (
                    0 !== filter.value.length &&
                    filter.value.toLowerCase() !==
                      object.vermarktungsart.toLowerCase()
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "regio":
                  // Check if the value can be worked with
                  if (this.geoWerftData.checkboxes.list_map_switcher) {
                    if (!object.geolage) {
                      result = false;
                      break;
                    }

                    // Check if a status is given
                    if (
                      0 !== filter.value.length &&
                      filter.value.toLowerCase() !==
                        object.geolage.toLowerCase()
                    ) {
                      result = false;
                      break;
                    }
                  }
                  break;
                case "kennung":
                  if (!object.kennung) {
                    result = false;
                    break;
                  }
                  if (
                    0 !== filter.value.length &&
                    -1 === object.kennung.trim().indexOf(filter.value.trim())
                  ) {
                    result = false;
                    break;
                  }
                  break;
                case "checkbox_barriere":
                  if (
                    filter.value &&
                    !(true === filter.value && object.barrierefrei === "1")
                  ) {
                    result = false;
                  }
                  break;
                case "checkbox_haustiere":
                  if (
                    filter.value &&
                    !(true === filter.value && object.haustiere === "1")
                  ) {
                    result = false;
                  }
                  break;
                default:
                  break;
              }
            }
          }
        }

        // Return the filter result
        return result;
      });
    },
    visible0bjects: function () {
      if (false === this.geoWerftData.map_enabled) {
        return this.geoWerftData.objects.filtered;
      }
      return this.geoWerftData.objects.filtered.filter((object) => {
        let minLat = Math.min.apply(Math, [
            this.geoWerftData.map.bound.northEast.lat,
            this.geoWerftData.map.bound.southWest.lat,
          ]),
          maxLat = Math.max.apply(Math, [
            this.geoWerftData.map.bound.northEast.lat,
            this.geoWerftData.map.bound.southWest.lat,
          ]),
          minLng = Math.min.apply(Math, [
            this.geoWerftData.map.bound.northEast.lng,
            this.geoWerftData.map.bound.southWest.lng,
          ]),
          maxLng = Math.max.apply(Math, [
            this.geoWerftData.map.bound.northEast.lng,
            this.geoWerftData.map.bound.southWest.lng,
          ]);

        return (
          object.geo_latitude > minLat &&
          object.geo_latitude < maxLat &&
          object.geo_longitude > minLng &&
          object.geo_longitude < maxLng
        );
      });
    },
  },
  watch: {
    allObjects(array) {
      // Call method to load images after the list objects got updated
    },
    filteredObjects(array) {
      this.geoWerftData.objects.filtered = array;
    },
    visible0bjects(array) {
      this.geoWerftData.objects.visible = array;
      if (
        false === this.geoWerftData.map_enabled ||
        "list" === this.geoWerftData.current_map_mode
      ) {
        this.geoWerftData.list_item_limit = 9999;
      } else {
        // Wert wieder auf den Anfangswert zurücksetzen.
        this.geoWerftData.list_item_limit = this.geoWerftData.list_item_limit_old;
      }
      // Limit the amount of items in the list
      this.geoWerftData.objects.listed = this.geoWerftData.objects.visible.slice(
        0,
        this.geoWerftData.list_item_limit
      );
    },
  },
  filters: {
    sanitize_title: function (value) {
      if (!value) {
        return "";
      }
      return value.replace(/\s+/g, "-").toLowerCase();
    },
  },
  methods: {
    applyExternalObjectsChange(payload) {
      const type = payload && payload.type;
      const items = Array.isArray(payload.items) ? payload.items : [];
      const key = payload && payload.key;
      const values = Array.isArray(payload.values) ? payload.values : [];

      const current = this.geoWerftData.objects.all || [];

      switch (type) {
        case "replace":
          // komplette Ersetzung
          this.$set(this.geoWerftData.objects, "all", items.slice());
          break;
        case "append":
          // anhängen
          this.$set(this.geoWerftData.objects, "all", current.concat(items));
          break;
        case "prepend":
          // voranstellen
          this.$set(this.geoWerftData.objects, "all", items.concat(current));
          break;
        case "clear":
          // leeren
          this.$set(this.geoWerftData.objects, "all", []);
          break;
        case "removeBy":
          // Elemente entfernen, wenn der Wert von key in values enthalten ist
          if (key) {
            const next = current.filter((it) => !values.includes(it[key]));
            this.$set(this.geoWerftData.objects, "all", next);
          }
          break;
        case "updateBy":
          // Elemente anhand key mergen/aktualisieren (id-basiert o.ä.)
          if (key) {
            const map = new Map(current.map((it) => [it[key], it]));
            for (const incoming of items) {
              const k = incoming && incoming[key];
              if (typeof k !== "undefined") {
                const prev = map.get(k) || {};
                map.set(k, { ...prev, ...incoming });
              }
            }
            this.$set(
              this.geoWerftData.objects,
              "all",
              Array.from(map.values())
            );
          }
          break;
        case "uniqueAppendBy":
          // nur neue (nicht vorhandene) anhand key anhängen
          if (key) {
            const existing = new Set(current.map((it) => it[key]));
            const toAdd = items.filter((it) => !existing.has(it[key]));
            this.$set(this.geoWerftData.objects, "all", current.concat(toAdd));
          }
          break;
        default:
          // Fallback: nichts tun
          break;
      }
    },
    async get_props(offset) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(
            this.geoWerftData.array_container.slice(
              offset,
              offset + parseInt(geowerftSettings.new_prop_data_per_load)
            )
          );
        }, parseInt(geowerftSettings.new_prop_data_load_time));
      });
    },
    async load_props(offset) {
      if (offset > parseInt(geowerftSettings.new_prop_data_max_count)) {
        this.geoWerftData.geowerft_immo_loading = false;
        return;
      }
      var that = this;
      this.get_props(offset).then(function (data) {
        that.geoWerftData.objects.all = that.geoWerftData.objects.all.concat(
          data
        );
        that.load_props(
          offset + parseInt(geowerftSettings.new_prop_data_per_load)
        );
      });
    },
    do_cookie_consent() {
      const cookie_bot = window.Cookiebot || "";
      if ("" !== cookie_bot) {
        cookie_bot.show();
      }
      if (window.CCM) {
        window.CCM.openWidget();
      }
    },
    get_consent_reset_class() {
      const cookie_bot = window.Cookiebot || "";
      let consent_reset_class =
        "mw-consent-management-reset-button avia-cookie-info-btn";
      if ("" !== cookie_bot || window.CCM) {
        consent_reset_class = "mw-consent-management-reset-button ";
      }
      return consent_reset_class;
    },
    loadPoperties(url, current_page, max_pages, fetch_header) {
      if (current_page > max_pages) {
        this.geoWerftData.geowerft_immo_loading = false;
        return;
      }

      // Change the url parameter
      url.searchParams.set("page", current_page.toString());
      // Fire of the requests
      this.$http.get(url.href, fetch_header).then(
        function (data) {
          // Success handling - more pages
          // Add received objects to the objects array
          data.body = this.reload_secret_sale_price(data.body);
          this.geoWerftData.objects.all = this.geoWerftData.objects.all.concat(
            data.body
          );
          current_page += 1;
          this.loadPoperties(url, current_page, max_pages, fetch_header);
        },
        function (data) {
          // Error handling - more pages
        }
      );
    },
    wordwrap(str, width, brk, cut) {
      brk = brk || "n";
      width = width || 75;
      cut = cut || false;

      if (!str) {
        return str;
      }

      let regex =
        ".{1," +
        width +
        "}(\s|$)" +
        (cut ? "|.{" + width + "}|.+$" : "|\S+?(\s|$)");

      return str.match(RegExp(regex, "g")).join(brk);
    },
    setSingleImage: function (imageObject) {
      let this_object = imageObject;
      // Check if an image has been set or is worked on
      if (
        typeof this_object.object_image_url === "undefined" &&
        typeof this_object.image_search_running === "undefined"
      ) {
        // No image found or worked on
        // Set the loading status to prevent double requests
        this.$set(this_object, "image_search_running", true);

        this.$set(
          this_object,
          "currency_suffix",
          this.geoWerftData.texts.currency_suffix
        );
        this.$set(
          this_object,
          "display_text_price_rent",
          this.geoWerftData.texts.display_text_price_rent
        );
        this.$set(
          this_object,
          "display_text_price_purchase",
          this.geoWerftData.texts.display_text_price_purchase
        );
        this.$set(
          this_object,
          "display_text_no_buyer_comission",
          this.geoWerftData.texts.display_text_no_buyer_comission
        );
        this.$set(
          this_object,
          "display_extra_banderole",
          this.geoWerftData.texts.display_extra_banderole
        );
        this.$set(
          this_object,
          "prop_loading_text",
          this.geoWerftData.texts.prop_loading_text
        );
        this.$set(
          this_object,
          "not_in_scope_text",
          this.geoWerftData.texts.not_in_scope_text
        );
        // Google Suche anzeigen.
        this.$set(
          this_object,
          "display_google_search",
          this.geoWerftData.checkboxes.display_google_search
        );
        this.$set(
          this_object,
          "display_custom_pin_in_list",
          this.geoWerftData.checkboxes.display_custom_pin_in_list
        );
        // Marker Icons
        this.$set(
          this_object,
          "google_maps_marker_online",
          this.geoWerftData.marker_image.google_maps_marker_online
        );
        this.$set(
          this_object,
          "google_maps_marker_in_vorbereitung",
          this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung
        );
        this.$set(
          this_object,
          "google_maps_marker_marktbeobachtung",
          this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung
        );
        this.$set(
          this_object,
          "google_maps_marker_verkauft",
          this.geoWerftData.marker_image.google_maps_marker_verkauft
        );
        this.$set(
          this_object,
          "google_maps_marker_referenz",
          this.geoWerftData.marker_image.google_maps_marker_referenz
        );
        this.$set(
          this_object,
          "google_maps_marker_secret_sale",
          this.geoWerftData.marker_image.google_maps_marker_secret_sale
        );
        this.$set(
          this_object,
          "google_maps_marker_neubauobjekt",
          this.geoWerftData.marker_image.google_maps_marker_neubauobjekt
        );
        this.$set(
          this_object,
          "google_maps_marker_neubaureferenz",
          this.geoWerftData.marker_image.google_maps_marker_neubaureferenz
        );
        this.$set(
          this_object,
          "google_maps_marker_exlusive_object",
          this.geoWerftData.marker_image.google_maps_marker_exlusive_object
        );
        this.$set(
          this_object,
          "google_maps_marker_badge_new",
          this.geoWerftData.marker_image.google_maps_marker_badge_new
        );
        this.$set(
          this_object,
          "google_maps_marker_auction",
          this.geoWerftData.marker_image.google_maps_marker_auction
        );
        this.$set(
          this_object,
          "google_maps_marker_mietboerse",
          this.geoWerftData.marker_image.google_maps_marker_mietboerse
        );
        this.$set(
          this_object,
          "google_maps_marker_immobiliendepot",
          this.geoWerftData.marker_image.google_maps_marker_immobiliendepot
        );
        this.$set(
          this_object,
          "google_maps_marker_default",
          this.geoWerftData.marker_image.google_maps_marker_default
        );
        this.$set(
          this_object,
          "google_search_zoom_level",
          this.geoWerftData.marker_image.google_search_zoom_level
        );
        this.$set(
          this_object,
          "no_immo_in_bounds_text",
          this.geoWerftData.marker_image.no_immo_in_bounds_text
        );
        this.$set(
          this_object,
          "no_immo_in_bounds_text_list_view",
          this.geoWerftData.marker_image.no_immo_in_bounds_text_list_view
        );
        this.$set(
          this_object,
          "format_prices_cb",
          this.geoWerftData.checkboxes.format_prices_cb
        );

        // Check if the object in on secret sale and user is not logged in
        if (
          typeof this_object.homepage_status !== "undefined" &&
          0 !== this_object.homepage_status.length &&
          "secret-sale" ===
            this.$options.filters.sanitize_title(this_object.homepage_status) &&
          !this.geoWerftData.user.logged_in
        ) {
          // Set a generic image, because the user is not allowed to see a real image
          this.$set(
            this_object,
            "object_image_url",
            this.geoWerftData.image_placeholder_secret
          );
        } else if (
          "aktive-marktbeobachtung" ===
          this.$options.filters.sanitize_title(this_object.homepage_status)
        ) {
          this.$set(
            this_object,
            "object_image_url",
            this.geoWerftData.image_placeholder_market_watch
          );
        } else if (
          this.geoWerftData.show_cluster &&
          this.geoWerftData.show_cluster_no_pictures
        ) {
          let that = this;
          that.$set(this_object, "object_image_url", "");
        } else {
          if (this.geoWerftData.checkboxes.enable_filialen_mode) {
            let img = new Image();
            let that = this;
            img.onload = function () {
              // Pre-loading done, set the image value to store
              that.$set(
                this_object,
                "object_image_url",
                this_object.object_image_url
              );
            };
            // Add image url to pre-loading
            img.src = this_object.object_image_url;
          } else {
            let image_url = this_object.map_picture;
            // Prepare a pre-loading
            let img = new Image();
            let that = this;
            img.onload = function () {
              // Pre-loading done, set the image value to store
              that.$set(this_object, "object_image_url", image_url);
            };
            // Add image url to pre-loading
            img.src = image_url;
          }
        }
        // Set searching flag to false to prevent infinity loops
        this.$set(this_object, "image_search_running", false);
      }
    },
    mw_set_main_geo_class() {
      let class_name = "geowerft-instant";
      if (true === this.geoWerftData.checkboxes.enable_filialen_mode) {
        class_name = class_name + " filialenwerft";
      }
      if (true === this.geoWerftData.enable_class_for_diff_view) {
        class_name = class_name + " erwerbsart-seperate";
      }
      if ("" !== this.geoWerftData.extra_map_css_class) {
        class_name = class_name + " " + this.geoWerftData.extra_map_css_class;
      }
      return class_name;
    },
    mw_interactive_remove_currency_and_not_working_chars(
      curreny_string,
      type = "currency"
    ) {
      let numeric_string = "0";
      if ("number" === type) {
        numeric_string = curreny_string.replaceAll(",", ".");
      }
      if ("buildyear_from" === type || "buildyear_to" === type) {
        return parseInt(curreny_string);
      }
      if ("currency" === type || "area" === type) {
        numeric_string = curreny_string
          .replaceAll(",00", "")
          .replaceAll(".", "");
      }
      return parseFloat(numeric_string);
    },
    reload_secret_sale_price: function (current_body) {
      // Hier wird geprüft welche Objekte Secret Sale sind und ob der Benutzer eingeloggt ist.
      // Dann mit der Ergebnisliste die Preise nachladen.
      if (
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.reload_secret_sale_price_for_logged_in
      ) {
        var arr_index = [];
        for (let array_index in current_body) {
          if (
            "secret sale" ===
            current_body[array_index]["homepage_status"].toLowerCase()
          ) {
            arr_index.push({
              index: array_index,
              id: current_body[array_index]["id"],
            });
          }
        }
        if (arr_index) {
          // Hier einen Ajax starten um die Preise für eingeloggte Benutzer zu erhalten.
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "return_secret_sale_price",
              index_and_id: arr_index,
            },
            success: function (response) {
              var arr_result = JSON.parse(response);
              for (let array_index in arr_result) {
                if ("rent" === current_body[array_index]["erwerbsart"]) {
                  current_body[array_index]["nettokaltmiete"] =
                    arr_result[array_index]["price"];
                } else {
                  current_body[array_index]["kaufpreis"] =
                    arr_result[array_index]["price"];
                }
              }
            },
          });
        }
      }
      return current_body;
    },
  },
  mounted() {
    // Globalen Listener registrieren
    this._onGWAllObjects = (e) => {
      try {
        const detail = (e && e.detail) || {};
        this.applyExternalObjectsChange(detail);
      } catch (err) {}
    };
    window.addEventListener(
      "mw_geowerft_change_list",
      this._onGWAllObjects,
      false
    );
  },
  beforeDestroy() {
    // Listener wieder entfernen, um Leaks zu vermeiden
    if (this._onGWAllObjects) {
      window.removeEventListener(
        "mw_geowerft_change_list",
        this._onGWAllObjects,
        false
      );
    }
  },
  created() {
    // Override geowerftSettings.center/zoom from URL params when a geo search is active.
    // URL params take precedence over PHP-set values and also fix the PHP lat/lng swap bug.
    {
      const urlParams = new URLSearchParams(window.location.search);
      const geoLat = urlParams.get("geo_values_lat");
      const geoLng = urlParams.get("geo_values_long");
      const qsSender = urlParams.get("quick_search_sender");
      const googleSearch = urlParams.get("google_search");

      if (
        (qsSender === "quick_search_send_post_data" ||
          (googleSearch !== null && googleSearch !== "")) &&
        geoLat !== null &&
        geoLat !== "" &&
        geoLng !== null &&
        geoLng !== ""
      ) {
        // Correct assignment (PHP has lat/lng swapped — geo_values_lat → lat, geo_values_long → lng).
        geowerftSettings.center = {
          lat: parseFloat(geoLat),
          lng: parseFloat(geoLng),
        };
        // Apply the geo-search zoom level (already user-aware from PHP theme mod).
        if (geowerftSettings.google_search_zoom_level) {
          geowerftSettings.zoom = parseInt(
            geowerftSettings.google_search_zoom_level
          );
        }
        // Ensure qs_used is set in the source URL.
        geowerftSettings.quicksearch_used = true;
      }
    }

    this.$set(
      this.geoWerftData,
      "show_more_filter_close_btn_label",
      geowerftSettings.show_more_filter_close_btn_label
    );
    this.$set(
      this.geoWerftData,
      "enable_ai_quick_chat",
      geowerftSettings.enable_ai_quick_chat
    );
    this.$set(
      this.geoWerftData,
      "enable_ai_quick_chat_custom",
      geowerftSettings.enable_ai_quick_chat_custom
    );
    this.$set(
      this.geoWerftData,
      "ai_quick_label",
      geowerftSettings.ai_quick_label
    );
    this.$set(
      this.geoWerftData,
      "ai_quick_placeholder",
      geowerftSettings.ai_quick_placeholder
    );
    this.$set(this.geoWerftData, "ai_load_text", geowerftSettings.ai_load_text);
    this.$set(this.geoWerftData, "ai_load_img", geowerftSettings.ai_load_img);
    this.$set(
      this.geoWerftData,
      "ai_load_img_pre",
      geowerftSettings.ai_load_img_pre
    );
    this.$set(
      this.geoWerftData,
      "ai_load_img_after",
      geowerftSettings.ai_load_img_after
    );
    this.$set(this.geoWerftData, "ai_quick_svg", geowerftSettings.ai_quick_svg);
    this.$set(
      this.geoWerftData,
      "list_view_config",
      geowerftSettings.list_view_config
    );
    this.$set(
      this.geoWerftData,
      "marketwatch_extern_links_hp",
      geowerftSettings.marketwatch_extern_links_hp
    );
    this.$set(
      this.geoWerftData,
      "interactive_filter_active",
      geowerftSettings.interactive_filter_active
    );
    this.$set(
      this.geoWerftData,
      "enable_comfort_zoom",
      geowerftSettings.enable_comfort_zoom
    );
    this.$set(
      this.geoWerftData,
      "enable_blacklist",
      geowerftSettings.enable_blacklist
    );
    this.$set(
      this.geoWerftData,
      "display_map_list_switch",
      geowerftSettings.display_map_list_switch
    );
    this.$set(this.geoWerftData, "reset_bounds", geowerftSettings.reset_bounds);
    this.$set(
      this.geoWerftData,
      "reset_bounds_label",
      geowerftSettings.reset_bounds_label
    );
    this.$set(
      this.geoWerftData,
      "price_on_request_cb",
      geowerftSettings.price_on_request_cb
    );
    this.$set(
      this.geoWerftData,
      "enable_class_for_diff_view",
      geowerftSettings.enable_class_for_diff_view
    );
    this.$set(
      this.geoWerftData,
      "extra_map_css_class",
      geowerftSettings.extra_map_css_class
    );
    this.$set(
      this.geoWerftData,
      "show_more_filter",
      geowerftSettings.show_more_filter
    );
    this.$set(
      this.geoWerftData,
      "show_dialog_filter",
      geowerftSettings.show_dialog_filter
    );
    this.$set(
      this.geoWerftData,
      "kennung_filter_caption",
      geowerftSettings.kennung_filter_caption
    );
    this.$set(
      this.geoWerftData,
      "energie_filter_caption",
      geowerftSettings.energie_filter_caption
    );
    this.$set(
      this.geoWerftData,
      "geo_business_mode",
      geowerftSettings.geo_business_mode
    );
    this.$set(
      this.geoWerftData,
      "watchlist_to_hide_hp",
      geowerftSettings.watchlist_to_hide_hp
    );
    this.$set(
      this.geoWerftData,
      "geo_business_mode_bueroflaeche",
      geowerftSettings.geo_business_mode_bueroflaeche
    );
    this.$set(
      this.geoWerftData,
      "watchlist_to_hide_vermarktung",
      geowerftSettings.watchlist_to_hide_vermarktung
    );
    this.$set(
      this.geoWerftData,
      "filialen_success_story_label",
      geowerftSettings.filialen_success_story_label
    );
    this.$set(
      this.geoWerftData,
      "filialen_landingpage_label",
      geowerftSettings.filialen_landingpage_label
    );
    this.$set(
      this.geoWerftData,
      "kennung_filter_placeholder",
      geowerftSettings.kennung_filter_placeholder
    );
    this.$set(
      this.geoWerftData,
      "energie_filter_placeholder",
      geowerftSettings.energie_filter_placeholder
    );
    this.$set(
      this.geoWerftData,
      "prop_watchlist_active",
      geowerftSettings.prop_watchlist_active
    );
    this.$set(
      this.geoWerftData,
      "prop_watchlist_offline_mode",
      geowerftSettings.prop_watchlist_offline_mode
    );
    this.$set(
      this.geoWerftData,
      "user_watchlist",
      geowerftSettings.user_watchlist
    );
    this.$set(
      this.geoWerftData,
      "user_watchlist_detailed",
      geowerftSettings.user_watchlist_detailed
    );
    this.$set(
      this.geoWerftData,
      "user_blacklist",
      geowerftSettings.user_blacklist
    );
    this.$set(
      this.geoWerftData,
      "user_blacklist_icon",
      geowerftSettings.user_blacklist_icon
    );
    this.$set(
      this.geoWerftData,
      "geo_display_objecttype",
      geowerftSettings.geo_display_objecttype
    );
    this.$set(
      this.geoWerftData,
      "use_buero_for_business_space",
      geowerftSettings.use_buero_for_business_space
    );
    this.$set(
      this.geoWerftData,
      "reload_secret_sale_price_for_logged_in",
      geowerftSettings.reload_secret_sale_price_for_logged_in
    );
    this.$set(
      this.geoWerftData,
      "no_prop_in_route_text",
      geowerftSettings.no_prop_in_route_text
    );
    this.$set(
      this.geoWerftData.texts,
      "diff_extern_link",
      geowerftSettings.diff_extern_link
    );
    this.$set(
      this.geoWerftData.texts,
      "label_details",
      geowerftSettings.label_details
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_label_price",
      geowerftSettings.filter_label_price
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_adults_label",
      geowerftSettings.filter_adults_label
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_children_label",
      geowerftSettings.filter_children_label
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_label_price_buy",
      geowerftSettings.filter_label_price_buy
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_label_price_rent",
      geowerftSettings.filter_label_price_rent
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_label_space",
      geowerftSettings.filter_label_space
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_label_rooms",
      geowerftSettings.filter_label_rooms
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_house",
      geowerftSettings.filter_space_label_house
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_grundstueck",
      geowerftSettings.filter_space_label_grundstueck
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_gewerbe",
      geowerftSettings.filter_space_label_gewerbe
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_invest",
      geowerftSettings.filter_space_label_invest
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_house_max_extension",
      geowerftSettings.filter_space_label_house_max_extension
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_grundstueck_max_extension",
      geowerftSettings.filter_space_label_grundstueck_max_extension
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_gewerbe_max_extension",
      geowerftSettings.filter_space_label_gewerbe_max_extension
    );
    this.$set(
      this.geoWerftData.texts,
      "filter_space_label_invest_max_extension",
      geowerftSettings.filter_space_label_invest_max_extension
    );
    this.$set(
      this.geoWerftData.texts,
      "custom_pre_filter_label_von",
      geowerftSettings.custom_pre_filter_label_von
    );
    this.$set(
      this.geoWerftData.texts,
      "custom_pre_filter_label_bis",
      geowerftSettings.custom_pre_filter_label_bis
    );
    this.$set(
      this.geoWerftData.texts,
      "consent_text_normal",
      geowerftSettings.consent_text_normal
    );
    this.$set(
      this.geoWerftData.texts,
      "consent_button_label",
      geowerftSettings.consent_button_label
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_picture",
      geowerftSettings.prop_offline_picture
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_success_text",
      geowerftSettings.prop_offline_success_text
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_explain_text",
      geowerftSettings.prop_offline_explain_text
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_akt_kind",
      geowerftSettings.prop_offline_akt_kind
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_akt_type",
      geowerftSettings.prop_offline_akt_type
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_hp_status",
      geowerftSettings.prop_offline_hp_status
    );
    this.$set(
      this.geoWerftData.texts,
      "exclude_in_closest_prop_status",
      geowerftSettings.exclude_in_closest_prop_status
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_offline_tutorial_text",
      geowerftSettings.prop_offline_tutorial_text
    );
    this.$set(
      this.geoWerftData.texts,
      "mietpreis_pro_qm_pre",
      geowerftSettings.mietpreis_pro_qm_pre
    );
    this.$set(
      this.geoWerftData.texts,
      "info_window_obj_nr",
      geowerftSettings.info_window_obj_nr
    );
    this.$set(
      this.geoWerftData.texts,
      "mietpreis_pro_qm_post",
      geowerftSettings.mietpreis_pro_qm_post
    );
    this.$set(this.geoWerftData.texts, "wp_nonce", geowerftSettings.wp_nonce);
    this.$set(
      this.geoWerftData.checkboxes,
      "prop_offline_include_overlay",
      geowerftSettings.prop_offline_include_overlay
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "user_has_searchwish",
      geowerftSettings.user_has_searchwish
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "picture_click_always_active",
      geowerftSettings.picture_click_always_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_map_satellite_switch",
      geowerftSettings.show_map_satellite_switch
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_price_in_paginated_info_window",
      geowerftSettings.show_price_in_paginated_info_window
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_ges_flaeche",
      geowerftSettings.display_ges_flaeche
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_tour_icon",
      geowerftSettings.display_tour_icon
    );
    this.$set(
      this.geoWerftData.customimages,
      "tour_icon_src",
      geowerftSettings.tour_icon_src
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "user_has_searchwish",
      geowerftSettings.user_has_searchwish
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "prop_offline_single_overlay",
      geowerftSettings.prop_offline_single_overlay
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "enable_filialen_mode",
      geowerftSettings.enable_filialen_mode
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "exclude_in_closest_prop",
      geowerftSettings.exclude_in_closest_prop
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "hide_picture_shadow",
      geowerftSettings.hide_picture_shadow
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_more_info_in_list",
      geowerftSettings.show_more_info_in_list
    );
    this.$set(
      this.geoWerftData,
      "filialien_url",
      geowerftSettings.filialien_url
    );
    this.$set(this.geoWerftData, "source_api", geowerftSettings.source_api);
    this.$set(
      this.geoWerftData,
      "estate_agent_email_filter",
      geowerftSettings.estate_agent_email_filter
    );
    this.$set(
      this.geoWerftData,
      "custom_map_style",
      geowerftSettings.custom_map_style
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "list_map_switcher",
      geowerftSettings.list_map_switcher
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "secret_bar_active",
      geowerftSettings.secret_bar_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_ground_fl_for_house_in_list",
      geowerftSettings.show_ground_fl_for_house_in_list
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "allow_prop_offline_detection",
      geowerftSettings.allow_prop_offline_detection
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "allow_prop_offline_detection_only_logged_in",
      geowerftSettings.allow_prop_offline_detection_only_logged_in
    );
    this.$set(
      this.geoWerftData.texts,
      "currency_suffix",
      geowerftSettings.currency_suffix
    );
    this.$set(
      this.geoWerftData.texts,
      "secret_bar_register_link",
      geowerftSettings.secret_bar_register_link
    );
    this.$set(
      this.geoWerftData.texts,
      "secret_sale_headline",
      geowerftSettings.secret_sale_headline
    );
    this.$set(
      this.geoWerftData.texts,
      "secret_sale_sub_text",
      geowerftSettings.secret_sale_sub_text
    );
    this.$set(
      this.geoWerftData.texts,
      "list_visibility_json",
      geowerftSettings.list_visibility_json
    );
    this.$set(
      this.geoWerftData.texts,
      "secret_sale_button",
      geowerftSettings.secret_sale_button
    );
    this.$set(
      this.geoWerftData,
      "secret_bar_max_count",
      geowerftSettings.secret_bar_max_count
    );
    this.$set(
      this.geoWerftData,
      "cluster_font_weight",
      geowerftSettings.cluster_font_weight
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "other_info_window",
      geowerftSettings.other_info_window
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "other_info_window_v2",
      geowerftSettings.other_info_window_v2
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_geo_as_fallback",
      geowerftSettings.show_geo_as_fallback
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_prep_price",
      geowerftSettings.display_prep_price
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_extra_commision_info",
      geowerftSettings.display_extra_commision_info
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_sorce_in_market_watch",
      geowerftSettings.display_sorce_in_market_watch
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "custom_marketwatch_temp_active",
      geowerftSettings.custom_marketwatch_temp_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "next_pin_active",
      geowerftSettings.next_pin_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "set_geolocation",
      geowerftSettings.set_geolocation
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "enable_tutorial",
      geowerftSettings.enable_tutorial
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "advanced_list_view",
      geowerftSettings.advanced_list_view
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "logged_in_market_watch",
      geowerftSettings.logged_in_market_watch
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "picture_click_active",
      geowerftSettings.picture_click_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "enable_market_watch_ajax",
      geowerftSettings.enable_market_watch_ajax
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_warmmiete",
      geowerftSettings.show_warmmiete
    );
    this.$set(
      this.geoWerftData.texts,
      "label_flaeche_list_view",
      geowerftSettings.label_flaeche_list_view
    );
    this.$set(
      this.geoWerftData.texts,
      "label_bezug_ab_map_view",
      geowerftSettings.label_bezug_ab_map_view
    );
    this.$set(
      this.geoWerftData.texts,
      "tutorial_text_one",
      geowerftSettings.tutorial_text_one
    );
    this.$set(
      this.geoWerftData.texts,
      "market_watch_alt_link",
      geowerftSettings.market_watch_alt_link
    );
    this.$set(
      this.geoWerftData.texts,
      "tutorial_text_two",
      geowerftSettings.tutorial_text_two
    );
    this.$set(
      this.geoWerftData.texts,
      "tutorial_text_three",
      geowerftSettings.tutorial_text_three
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "fill_prop_types_to_invest",
      geowerftSettings.fill_prop_types_to_invest
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_plz_in_object_place",
      geowerftSettings.display_plz_in_object_place
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_kennung_in_object_place",
      geowerftSettings.display_kennung_in_object_place
    );
    this.$set(
      this.geoWerftData.texts,
      "fill_prop_types_to_invest_list",
      geowerftSettings.fill_prop_types_to_invest_list
    );
    this.$set(
      this.geoWerftData.texts,
      "auction_popup_picture",
      geowerftSettings.auction_popup_picture
    );
    this.$set(this.geoWerftData.texts, "ajax_url", geowerftSettings.ajax_url);
    this.$set(
      this.geoWerftData.texts,
      "geo_banner_picture_src",
      geowerftSettings.geo_banner_picture_src
    );
    this.$set(
      this.geoWerftData.texts,
      "geo_banner_picture_src_list",
      geowerftSettings.geo_banner_picture_src_list
    );
    this.$set(
      this.geoWerftData.texts,
      "geo_banner_picture_link",
      geowerftSettings.geo_banner_picture_link
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_picture_link_second",
      geowerftSettings.banner_picture_link_second
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_picture_src_second",
      geowerftSettings.banner_picture_src_second
    );
    this.$set(
      this.geoWerftData.texts,
      "geo_banner_custom_html",
      geowerftSettings.geo_banner_custom_html
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_mobile_first_link",
      geowerftSettings.banner_mobile_first_link
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_mobile_first_px",
      geowerftSettings.banner_mobile_first_px
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_mobile_second_link",
      geowerftSettings.banner_mobile_second_link
    );
    this.$set(
      this.geoWerftData.texts,
      "banner_mobile_second_px",
      geowerftSettings.banner_mobile_second_px
    );
    this.$set(
      this.geoWerftData.texts,
      "market_watch_akt_kind",
      geowerftSettings.market_watch_akt_kind
    );
    this.$set(
      this.geoWerftData.texts,
      "market_watch_akt_type",
      geowerftSettings.market_watch_akt_type
    );
    this.$set(
      this.geoWerftData.customimages,
      "tutorial_picture_one",
      geowerftSettings.tutorial_picture_one
    );
    this.$set(
      this.geoWerftData.customimages,
      "tutorial_picture_two",
      geowerftSettings.tutorial_picture_two
    );
    this.$set(
      this.geoWerftData.customimages,
      "tutorial_picture_three",
      geowerftSettings.tutorial_picture_three
    );
    this.$set(
      this.geoWerftData.texts,
      "blur_hp_status_name",
      geowerftSettings.blur_hp_status_name
    );
    this.$set(
      this.geoWerftData.texts,
      "text_next_pin_prop",
      geowerftSettings.text_next_pin_prop
    );
    this.$set(
      this.geoWerftData.texts,
      "text_button_next_pin_prop",
      geowerftSettings.text_button_next_pin_prop
    );
    this.$set(
      this.geoWerftData.texts,
      "text_filter_next_pin_prop",
      geowerftSettings.text_filter_next_pin_prop
    );
    this.$set(
      this.geoWerftData.texts,
      "text_next_pin_ppl",
      geowerftSettings.text_next_pin_ppl
    );
    this.$set(
      this.geoWerftData.texts,
      "text_button_next_pin_ppl",
      geowerftSettings.text_button_next_pin_ppl
    );
    this.$set(
      this.geoWerftData.texts,
      "text_sc_info_text",
      geowerftSettings.text_sc_info_text
    );
    this.$set(
      this.geoWerftData.texts,
      "autocomplete_placeholder",
      geowerftSettings.autocomplete_placeholder
    );
    this.$set(
      this.geoWerftData.texts,
      "market_watch_name",
      geowerftSettings.market_watch_name
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_own_source_text",
      geowerftSettings.prop_own_source_text
    );
    this.$set(this.geoWerftData.texts, "map_h1", geowerftSettings.map_h1);
    this.$set(this.geoWerftData.texts, "sc_plz", geowerftSettings.sc_plz);
    this.$set(
      this.geoWerftData.texts,
      "sc_geolage",
      geowerftSettings.sc_geolage
    );
    this.$set(
      this.geoWerftData.texts,
      "zoom_out_type",
      geowerftSettings.zoom_out_type
    );

    this.$set(
      this.geoWerftData.user,
      "current_user_id",
      geowerftSettings.current_user_id
    );

    this.$set(
      this.geoWerftData.user,
      "user_fully_logged_in",
      geowerftSettings.user_fully_logged_in
    );

    this.$set(
      this.geoWerftData.user,
      "link_for_logged_in_only",
      geowerftSettings.link_for_logged_in_only
    );

    this.$set(
      this.geoWerftData.user,
      "link_for_logged_in_only_url",
      geowerftSettings.link_for_logged_in_only_url
    );

    this.$set(
      this.geoWerftData.user,
      "link_for_logged_in_only_label",
      geowerftSettings.link_for_logged_in_only_label
    );

    if (
      undefined !== this.geoWerftData.texts.zoom_out_type &&
      "" !== this.geoWerftData.texts.zoom_out_type
    ) {
      let zoom_types = this.geoWerftData.texts.zoom_out_type.split("#");
      for (let i = 0; i < zoom_types.length; i++) {
        let zoom_type = zoom_types[i].split("|");
        this.geoWerftData.map.zoom_types.push({
          type: zoom_type[0],
          zoom: zoom_type[1],
          lat: zoom_type[2],
          lng: zoom_type[3],
        });
      }
    }
    // Check if settings object was found
    if (!geowerftSettings) {
      // Set error for user
      this.geoWerftData.hasError = "Missing settings";
      // Stop here
      return;
    }
    // Check if settings object contains source url
    if (!geowerftSettings.source_url) {
      // Set error for user
      this.geoWerftData.hasError = "Missing source url";
    } else if (false === this.geoWerftData.interactive_filter_active) {
      // Wenn der Filialien Modus an ist andere Rute verwenden
      if (this.geoWerftData.checkboxes.enable_filialen_mode) {
        this.geoWerftData.source_url =
          this.geoWerftData.filialien_url +
          "?per_page=" +
          geowerftSettings.page_count +
          "&_fields=id,list_position,geo_longitude,geo_latitude,objekt_titel,ort,strasse,plz,email,fax,telefon,telefon_zwei,link,object_image_url,info_head,info_ort,success_story&filter[orderby]=title&order=asc";
      } else {
        // Prepare vars
        let option_counter = 0,
          option_counter_query = 0,
          homepageStatusFilterInRequestString = "",
          vermarktungsartFilterInRequestString = "",
          plzFilterInRequestString = "",
          geolageFilterInRequestString = "",
          apiFilterInRequestString = "",
          agentEmailFilterInRequestString = "";

        let addTag = "";
        addTag = "query][" + option_counter_query + "][";
        // Loop all filter options for homepage_status
        for (let option_key in geowerftSettings.filter.status.options) {
          // Add the value to the query
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString +
            "&filter[meta_" +
            addTag +
            "value][" +
            option_counter +
            "]=" +
            option_key; // Hier die Value verwenden und nicht das label aus der Option.
          // Increase counter to build an array inside the query
          option_counter++;
        }

        // Always set the filter to prevents loading posts with empty homepage_status and as key for homepage_status values
        homepageStatusFilterInRequestString =
          "&filter[meta_" +
          addTag +
          "key]=homepage_status" +
          homepageStatusFilterInRequestString;

        if (
          undefined !== geowerftSettings.show_only_with_ogulo_tour &&
          "1" === geowerftSettings.show_only_with_ogulo_tour
        ) {
          option_counter_query = option_counter_query + 1;
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString +
            "&filter[meta_query][" +
            option_counter_query +
            "][key]=ogulo_tour&filter[meta_query][" +
            option_counter_query +
            "][value]=ja";
        }

        let m_options = 0;
        if (undefined !== geowerftSettings.filter.marketing) {
          for (let option_key in geowerftSettings.filter.marketing.options) {
            m_options++;
          }
        }

        if (0 < m_options) {
          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (let option_key in geowerftSettings.filter.marketing.options) {
            // Add the value to the query
            vermarktungsartFilterInRequestString =
              vermarktungsartFilterInRequestString +
              "&filter[meta_" +
              addTag +
              "value][" +
              option_counter +
              "]=" +
              geowerftSettings.filter.marketing.options[option_key];
            // Increase counter to build an array inside the query
            option_counter++;
          }
          vermarktungsartFilterInRequestString =
            "&filter[meta_" +
            addTag +
            "key]=vermarktungsart" +
            vermarktungsartFilterInRequestString;

          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString +
            vermarktungsartFilterInRequestString;
        }
        // if source API is set, add the request
        if ("" !== this.geoWerftData.source_api) {
          let sourceApis = this.geoWerftData.source_api.split("xxxx");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (let i = 0; i < sourceApis.length; i++) {
            // Add the value to the query
            apiFilterInRequestString =
              apiFilterInRequestString +
              "&filter[meta_" +
              addTag +
              "value][" +
              option_counter +
              "]=" +
              sourceApis[i];
            // Increase counter to build an array inside the query
            option_counter++;
          }

          homepageStatusFilterInRequestString =
            "&filter[meta_query][relation]=AND" +
            homepageStatusFilterInRequestString +
            "&filter[meta_query][" +
            option_counter_query +
            "][key]=_source_api" +
            apiFilterInRequestString;
        }

        //If estate_agent_email_filter is set add it to the request
        if ("" !== this.geoWerftData.estate_agent_email_filter) {
          let sourceEmails = this.geoWerftData.estate_agent_email_filter.split(
            "xxxx"
          );
          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";
          for (let i = 0; i < sourceEmails.length; i++) {
            // Add the value to the query
            agentEmailFilterInRequestString =
              agentEmailFilterInRequestString +
              "&filter[meta_" +
              addTag +
              "value][" +
              option_counter +
              "]=" +
              sourceEmails[i];
            // Increase counter to build an array inside the query
            option_counter++;
          }

          homepageStatusFilterInRequestString =
            // "&filter[meta_query][relation]=AND" +
            homepageStatusFilterInRequestString +
            "&filter[meta_query][" +
            option_counter_query +
            "][key]=kontaktperson_email_direkt" +
            agentEmailFilterInRequestString;
        }

        // if sc_plz is set, add the request
        if ("" !== this.geoWerftData.texts.sc_plz) {
          let arr_plz = this.geoWerftData.texts.sc_plz.split("|");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (let i = 0; i < arr_plz.length; i++) {
            // Add the value to the query
            plzFilterInRequestString =
              plzFilterInRequestString +
              "&filter[meta_" +
              addTag +
              option_counter +
              "][compare]=REGEXP&filter[meta_" +
              addTag +
              option_counter +
              "][key]=plz&filter[meta_" +
              addTag +
              option_counter +
              "][value]=^[[" +
              this.wordwrap(arr_plz[i], 1, "][", true) +
              "]]*";
            // Increase counter to build an array inside the query
            option_counter++;
          }
          plzFilterInRequestString =
            "&filter[meta_" +
            addTag +
            "relation]=OR" +
            plzFilterInRequestString;
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString + plzFilterInRequestString;
        }

        // if sc_geolage is set, add the request
        if ("" !== this.geoWerftData.texts.sc_geolage) {
          let arr_geolage = this.geoWerftData.texts.sc_geolage.split("|");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (let i = 0; i < arr_geolage.length; i++) {
            // Add the value to the query
            geolageFilterInRequestString =
              geolageFilterInRequestString +
              "&filter[meta_" +
              addTag +
              option_counter +
              "][compare]=REGEXP&filter[meta_" +
              addTag +
              option_counter +
              "][key]=geolage_wert&filter[meta_" +
              addTag +
              option_counter +
              "][value]=^" +
              arr_geolage[i].replaceAll("+", ".") +
              ".*";
            // Increase counter to build an array inside the query
            option_counter++;
          }
          geolageFilterInRequestString =
            "&filter[meta_" +
            addTag +
            "relation]=OR" +
            geolageFilterInRequestString;

          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString + geolageFilterInRequestString;
        }

        // Min Request
        homepageStatusFilterInRequestString =
          homepageStatusFilterInRequestString +
          "&_fields=homepage_status,erwerbsart,anzahl_zimmer,kaufpreis,nettokaltmiete,vermarktungsart,objektart_raw,objektart_geowerft,objekttyp,id,geo_latitude,geo_longitude,link_extern,object_image_url,objekttitel,plz,ort,kennung,wohnflaeche,vermietbare_flaeche,grundstuecksflaeche,gesamtflaeche,link,reservierung_ende,reservierung_begin,map_pin,map_picture,geolage,display_badge_new,mw_auction_current_price,aussencourtage_ja,count_adults,count_childs,barrierefrei,haustiere,ogulo_tour,epass_wertklasse,mw_map_star_rating";

        // Wenn das Custom Meta Feld gefüllt wurde.
        if ("" !== (geowerftSettings.custom_compare_meta || "")) {
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString +
            "," +
            geowerftSettings.custom_compare_meta;
        }

        // Wenn Bussiness Felder noch hinzugefügt werden sollen.
        if (true === this.geoWerftData.geo_business_mode) {
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString +
            ",mietpreis_pro_qm,bueroflaeche,teilbar_ab,bezug";
        }

        //Warmmiete hinzufügen, wenn im Customizer so ausgewählt
        if (true === this.geoWerftData.checkboxes.show_warmmiete) {
          homepageStatusFilterInRequestString =
            homepageStatusFilterInRequestString + ",warmmiete";
        }

        // Custom Felder variabel mit GTB hinzufügen.
        if ("" !== (geowerftSettings.custom_meta_extender || "")) {
          homepageStatusFilterInRequestString +=
            "," + geowerftSettings.custom_meta_extender;
        }

        // Set value from settings object
        var url_seperator = "?";
        if (geowerftSettings.source_url.indexOf("?") > -1) {
          url_seperator = "&";
        }
        this.geoWerftData.source_url =
          geowerftSettings.source_url +
          url_seperator +
          "per_page=" +
          geowerftSettings.page_count +
          homepageStatusFilterInRequestString +
          "&lat=" +
          geowerftSettings.center.lat +
          "&lon=" +
          geowerftSettings.center.lng +
          "&qs_used=" +
          geowerftSettings.quicksearch_used;
      }
    }

    this.$set(
      this.geoWerftData,
      "list_item_limit",
      geowerftSettings.list_item_limit
    );
    this.$set(
      this.geoWerftData,
      "list_item_limit_old",
      geowerftSettings.list_item_limit
    );
    this.$set(this.geoWerftData, "show_cluster", geowerftSettings.show_cluster);
    this.$set(
      this.geoWerftData,
      "show_cluster_no_pictures",
      geowerftSettings.show_cluster_no_pictures
    );
    this.$set(
      this.geoWerftData,
      "cluster_break_zoom",
      geowerftSettings.cluster_break_zoom
    );
    this.$set(
      this.geoWerftData,
      "cluster_pin_near",
      geowerftSettings.cluster_pin_near
    );
    this.$set(
      this.geoWerftData,
      "cluster_pin_far",
      geowerftSettings.cluster_pin_far
    );
    this.$set(
      this.geoWerftData,
      "show_sold_banner",
      geowerftSettings.show_sold_banner
    );
    this.$set(this.geoWerftData, "steps_rooms", geowerftSettings.steps_rooms);
    this.$set(this.geoWerftData, "steps_space", geowerftSettings.steps_space);
    this.$set(
      this.geoWerftData,
      "steps_living_space",
      geowerftSettings.steps_living_space
    );
    this.$set(
      this.geoWerftData,
      "steps_plot_space",
      geowerftSettings.steps_plot_space
    );
    this.$set(
      this.geoWerftData,
      "auction_list_label",
      geowerftSettings.auction_list_label
    );
    this.$set(
      this.geoWerftData,
      "geowerft_setting_watchlist_icon",
      geowerftSettings.geowerft_setting_watchlist_icon
    );
    this.$set(
      this.geoWerftData,
      "geowerft_setting_watchlist_icon_custom",
      geowerftSettings.geowerft_setting_watchlist_icon_custom
    );
    this.$set(
      this.geoWerftData,
      "show_einheiten_in_list",
      geowerftSettings.show_einheiten_in_list
    );
    this.$set(
      this.geoWerftData,
      "geowerft_gtb_active",
      geowerftSettings.geowerft_gtb_active
    );
    this.$set(
      this.geoWerftData,
      "use_img_tag_in_list",
      geowerftSettings.use_img_tag_in_list
    );
    this.$set(
      this.geoWerftData,
      "geowerft_gtb_watchlist_active",
      geowerftSettings.geowerft_gtb_watchlist_active
    );
    this.$set(
      this.geoWerftData,
      "geowerft_gtb_watchlist_active_detailed",
      geowerftSettings.geowerft_gtb_watchlist_active_detailed
    );
    this.$set(
      this.geoWerftData,
      "geowerft_gtb_watchlist_rest",
      geowerftSettings.geowerft_gtb_watchlist_rest
    );
    this.$set(
      this.geoWerftData,
      "show_prov_free_banner",
      geowerftSettings.show_prov_free_banner
    );
    this.$set(
      this.geoWerftData,
      "step_num_kauf",
      geowerftSettings.step_num_kauf
    );
    this.$set(
      this.geoWerftData,
      "step_num_miete",
      geowerftSettings.step_num_miete
    );
    this.$set(
      this.geoWerftData,
      "show_extern_link",
      geowerftSettings.show_extern_link
    );

    // Set texts from customizer.
    this.$set(
      this.geoWerftData.texts,
      "display_text_price_rent",
      geowerftSettings.display_text_price_rent
    );
    this.$set(
      this.geoWerftData.texts,
      "display_text_price_purchase",
      geowerftSettings.display_text_price_purchase
    );
    this.$set(
      this.geoWerftData.texts,
      "display_text_no_buyer_comission",
      geowerftSettings.display_text_no_buyer_comission
    );
    this.$set(
      this.geoWerftData.texts,
      "display_extra_banderole",
      geowerftSettings.display_extra_banderole
    );
    this.$set(
      this.geoWerftData.texts,
      "no_immo_in_bounds_text",
      geowerftSettings.no_immo_in_bounds_text
    );
    this.$set(
      this.geoWerftData.texts,
      "no_immo_in_bounds_text_list_view",
      geowerftSettings.no_immo_in_bounds_text_list_view
    );
    this.$set(
      this.geoWerftData.texts,
      "prop_loading_text",
      geowerftSettings.prop_loading_text
    );
    this.$set(
      this.geoWerftData.texts,
      "not_in_scope_text",
      geowerftSettings.not_in_scope_text
    );
    this.$set(
      this.geoWerftData.texts,
      "select_cluster_hp_to_show",
      geowerftSettings.select_cluster_hp_to_show
    );
    this.$set(
      this.geoWerftData.map_settings,
      "google_search_zoom_level",
      geowerftSettings.google_search_zoom_level
    );

    // Additional infos
    this.$set(
      this.geoWerftData.additional_content,
      "geowerft_additional_info_box",
      geowerftSettings.geowerft_additional_info_box
    );
    this.$set(
      this.geoWerftData.additional_content,
      "geowerft_additional_info_box_template",
      geowerftSettings.geowerft_additional_info_box_template
    );

    // Set checkboxes from customizer.
    this.$set(
      this.geoWerftData.checkboxes,
      "display_google_search",
      geowerftSettings.display_google_search
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "select_cluster_active",
      geowerftSettings.select_cluster_active
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_custom_pin_in_list",
      geowerftSettings.display_custom_pin_in_list
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "format_prices_cb",
      geowerftSettings.format_prices_cb
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_price_prop_sold",
      geowerftSettings.show_price_prop_sold
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_in_prep_banner",
      geowerftSettings.show_in_prep_banner
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_price_prop_referenz",
      geowerftSettings.show_price_prop_referenz
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "show_loading_icon",
      geowerftSettings.show_loading_icon
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_marketing_method",
      geowerftSettings.display_marketing_method
    );
    this.$set(
      this.geoWerftData.checkboxes,
      "display_picture_max_width_or_height",
      geowerftSettings.display_picture_max_width_or_height
    );
    this.$set(
      this.geoWerftData,
      "custom_loading_icon",
      geowerftSettings.custom_loading_icon
    );

    // Set Marker Images
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_online",
      geowerftSettings.google_maps_marker_online
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_in_vorbereitung",
      geowerftSettings.google_maps_marker_in_vorbereitung
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_marktbeobachtung",
      geowerftSettings.google_maps_marker_marktbeobachtung
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_verkauft",
      geowerftSettings.google_maps_marker_verkauft
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_referenz",
      geowerftSettings.google_maps_marker_referenz
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_secret_sale",
      geowerftSettings.google_maps_marker_secret_sale
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_neubauobjekt",
      geowerftSettings.google_maps_marker_neubauobjekt
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_neubaureferenz",
      geowerftSettings.google_maps_marker_neubaureferenz
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_exlusive_object",
      geowerftSettings.google_maps_marker_exlusive_object
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_badge_new",
      geowerftSettings.google_maps_marker_badge_new
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_auction",
      geowerftSettings.google_maps_marker_auction
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_mietboerse",
      geowerftSettings.google_maps_marker_mietboerse
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_immobiliendepot",
      geowerftSettings.google_maps_marker_immobiliendepot
    );
    this.$set(
      this.geoWerftData.marker_image,
      "google_maps_marker_default",
      geowerftSettings.google_maps_marker_default
    );
    this.$set(
      this.geoWerftData.map,
      "map_type_id",
      geowerftSettings.map_type_id
    );
    this.$set(
      this.geoWerftData.map,
      "map_touch_mode",
      geowerftSettings.map_touch_mode
    );
    this.$set(
      this.geoWerftData.map,
      "map_zoom_control",
      geowerftSettings.map_zoom_control
    );

    // Set the media URL
    this.geoWerftData.media_url = geowerftSettings.media_url;

    // Check map zoom settings
    if (!geowerftSettings.zoom) {
      // Set error for user
      this.geoWerftData.hasError = "Missing zoom level setting";
    } else {
      // Set the value from settings object
      this.geoWerftData.map.zoom = parseInt(geowerftSettings.zoom);
    }

    // Check maps max zoom level
    if (0 !== parseInt(geowerftSettings.max_zoom)) {
      // Set the value from settings object
      this.$set(
        this.geoWerftData.map,
        "maxZoom",
        parseInt(geowerftSettings.max_zoom)
      );
    }

    /*
     * Set placeholder images
     */
    // Placeholder - Secret sale
    this.$set(
      this.geoWerftData,
      "image_placeholder_secret",
      geowerftSettings.image_placeholder_secret
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_secret) {
      // Prepare a pre-loading
      let secret_sales_image = new Image();
      secret_sales_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      secret_sales_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - Aktive Marktbeobachtung
    this.$set(
      this.geoWerftData,
      "image_placeholder_market_watch",
      geowerftSettings.image_placeholder_market_watch
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_market_watch) {
      // Prepare a pre-loading
      let market_watch_image = new Image();
      market_watch_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      market_watch_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Haus.
    this.$set(
      this.geoWerftData,
      "image_placeholder_house_prep",
      geowerftSettings.image_placeholder_house_prep
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_house_prep) {
      // Prepare a pre-loading
      let house_prep_image = new Image();
      house_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      house_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Wohnung.
    this.$set(
      this.geoWerftData,
      "image_placeholder_flat_prep",
      geowerftSettings.image_placeholder_flat_prep
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_flat_prep) {
      // Prepare a pre-loading
      let flat_prep_image = new Image();
      flat_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      flat_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Grundstück.
    this.$set(
      this.geoWerftData,
      "image_placeholder_plot_prep",
      geowerftSettings.image_placeholder_plot_prep
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_plot_prep) {
      // Prepare a pre-loading
      let plot_prep_image = new Image();
      plot_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      plot_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Grundstück.
    this.$set(
      this.geoWerftData,
      "image_placeholder_invest_prep",
      geowerftSettings.image_placeholder_invest_prep
    );
    this.$set(
      this.geoWerftData,
      "image_placeholder_market_watch_house",
      geowerftSettings.image_placeholder_market_watch_house
    );
    this.$set(
      this.geoWerftData,
      "image_placeholder_market_watch_flat",
      geowerftSettings.image_placeholder_market_watch_flat
    );
    this.$set(
      this.geoWerftData,
      "image_placeholder_market_watch_plot",
      geowerftSettings.image_placeholder_market_watch_plot
    );
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_invest_prep) {
      // Prepare a pre-loading
      let invest_prep_image = new Image();
      invest_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      invest_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - No image or still loading
    this.$set(
      this.geoWerftData,
      "image_placeholder_empty",
      geowerftSettings.image_placeholder_empty
    );
    // Pre-load the empty placeholder
    if ("" !== this.geoWerftData.image_placeholder_empty) {
      // Prepare a pre-loading
      let placeholder_image = new Image();
      placeholder_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      placeholder_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Check map center point setting
    if (
      !geowerftSettings.center ||
      "object" !== typeof geowerftSettings.center
    ) {
      // Set error for user
      this.geoWerftData.hasError = "Missing center point setting";
    } else {
      // Set the values from settings object
      this.geoWerftData.map.center.lat = parseFloat(
        geowerftSettings.center.lat
      );
      this.geoWerftData.map.center.lng = parseFloat(
        geowerftSettings.center.lng
      );
    }

    if (document.body.classList.contains("logged-in")) {
      this.geoWerftData.user.logged_in = true;
    }

    let fetch_header = {};
    if (this.geoWerftData.texts.wp_nonce) {
      fetch_header = {
        headers: { "X-WP-Nonce": this.geoWerftData.texts.wp_nonce },
      };
    }

    if (geowerftSettings.raw_data) {
      this.$set(
        this.geoWerftData,
        "array_container",
        JSON.parse(geowerftSettings.raw_data)
      );

      var that = this;
      this.get_props(0).then(function (data) {
        that.geoWerftData.objects.all = data;
        that.load_props(0 + parseInt(geowerftSettings.new_prop_data_per_load));
      });
    } else if (true === geowerftSettings.use_raw_data) {
      // Nutzer scheint nicht eingeloggt zu sein.
      // Daten aus der REST holen.
      this.$http
        .get(geowerftSettings.cached_url, fetch_header)
        .then((data) => {
          this.geoWerftData.objects.all = data.body.data;
          this.geoWerftData.geowerft_immo_loading = false;
          dispatchEvent(
            new CustomEvent("mw_map_list_loaded", {
              detail: { all_loaded_props: this.geoWerftData.objects.all },
              bubbles: true,
            })
          );
        })
        .catch((error) => {
          this.geoWerftData.geowerft_immo_loading = false;
          this.geoWerftData.geowerft_no_props_from_route = true;
        });
    } else {
      // Fetch the data from WP REST API
      this.$http.get(this.geoWerftData.source_url, fetch_header).then(
        function (data) {
          // Success handling - first page
          // Put the result into the bus
          data.body = this.reload_secret_sale_price(data.body);
          this.geoWerftData.objects.all = data.body;
          //this.$set( this.geoWerftData, 'is_loading', false );

          // Get the max number of pages to loop over
          const page_count = parseInt(data.headers.get("X-WP-TotalPages"));

          // Create url object
          let url = new URL(this.geoWerftData.source_url);
          // Loop all pages
          this.loadPoperties(url, 2, page_count, fetch_header);
        },
        function (data) {
          // Error handling - first page
          // do nothing for now
        }
      );
    }

    // Set the filter

    if (
      !geowerftSettings.filter ||
      "object" === typeof geowerftSettings.filter
    ) {
      this.geoWerftData.filter = geowerftSettings.filter;
    }

    // Pre-select filter if settings say so
    if (undefined !== geowerftSettings.query) {
      // Loop all filters
      for (let key in geowerftSettings.query) {
        // Check if a good key is given
        if ("string" === typeof geowerftSettings.query[key]) {
          // Store the value into var
          let value = geowerftSettings.query[key].toLowerCase();
          // Use the fresh shortcode input.
          let statusval = geowerftSettings.query[key];

          // Check if strings need to be translated
          switch (key) {
            case "erwerbsart":
              // Rewrite key to english
              key = "acquisition";
              // Rewrite value to english
              switch (value) {
                case "miete":
                  value = "rent";
                  break;
                case "kauf":
                  value = "buy";
                  break;
              }
              break;
            case "objektart_geowerft":
            case "objektart":
              // Rewrite key to english
              key = "objecttype";
              // Rewrite value to english
              switch (value) {
                case "haus":
                  value = "house";
                  break;
                case "wohnung":
                  value = "flat";
                  break;
                case "grundstück":
                  value = "plot";
                  break;
                case "investment":
                  value = "investment";
                  break;
                case "gewerbe":
                  value = "business";
                  break;
              }
              break;
            case "homepage_status":
              // Rewrite key to english
              key = "status";
              value = statusval;
              // Rewrite value to english
              break;
            case "vermarktungsart":
              // Rewrite key to english
              key = "marketing";
              value = statusval;
              // Rewrite value to english
              break;
            case "geolage":
              // Rewrite key to english
              key = "regio";
              value = statusval;
              // Rewrite value to english
              break;
          }

          // Set the filter to it's value
          this.geoWerftData.filter[key].value = value;
        }
      }
    }

    // URL params take final precedence over both PHP filter defaults and shortcode query attribute.
    if (this.geoWerftData.filter) {
      const urlParams = new URLSearchParams(window.location.search);
      if (
        urlParams.get("quick_search_sender") === "quick_search_send_post_data"
      ) {
        const urlAcquisition = urlParams.get("quick-erwerbsart");
        const urlObjecttype = urlParams.get("quick-objektarten");
        if (
          urlAcquisition &&
          urlAcquisition !== "leer" &&
          this.geoWerftData.filter["acquisition"]
        ) {
          this.geoWerftData.filter["acquisition"].value = urlAcquisition;
        }
        if (
          urlObjecttype &&
          urlObjecttype !== "leer" &&
          this.geoWerftData.filter["objecttype"]
        ) {
          this.geoWerftData.filter["objecttype"].value = urlObjecttype;
        }
      }
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/GeoWerft.vue